import { defer } from "react-router-dom";

import { projectsQuery } from "@/services/lukita/queries";
import { getAccount, getQueryParams } from "../helpers";

export default function projectsLoader({ request }) {
  const { skip, first } = getQueryParams(request.url);
  const url = new URL(request.url);
  const requestPolicy = url.searchParams.has("success") ? "network-only" : null;

  const projects = getAccount()
    .then((account) =>
      projectsQuery({
        accountId: account?.id,
        skip,
        first,
        requestOptions: { requestPolicy },
      }),
    )
    .then(({ projects, metadata }) => ({ items: projects, metadata }));

  return defer({ projects });
}
